var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTasks({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14.857,
    height: 16.286,
    viewBox: "0 0 14.857 16.286",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3127",
    "data-name": "Group 3127",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3126",
    "data-name": "Group 3126"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8472",
    "data-name": "Path 8472",
    d: "M11.855,5.8,7.484,8.464a1.505,1.505,0,0,1-1.539,0L1.575,5.8a1.089,1.089,0,0,1,0-1.917l4.37-2.668a1.509,1.509,0,0,1,1.539,0l4.371,2.668A1.089,1.089,0,0,1,11.855,5.8Z",
    transform: "translate(-0.286 -0.286)",
    fill: "none",
    stroke: "#16161a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8473",
    "data-name": "Path 8473",
    d: "M1,9.962a1.116,1.116,0,0,0,.574.984l.55.339,3.819,2.329a1.515,1.515,0,0,0,1.543,0L11.3,11.286l.551-.339a1.12,1.12,0,0,0,.574-.957",
    transform: "translate(-0.286 -2.846)",
    fill: "none",
    stroke: "#16161a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8474",
    "data-name": "Path 8474",
    d: "M12.428,13.657a1.133,1.133,0,0,1-.573.918L7.487,17.244a1.52,1.52,0,0,1-1.544,0L1.574,14.575A1.124,1.124,0,0,1,1,13.59",
    transform: "translate(-0.286 -3.883)",
    fill: "none",
    stroke: "#16161a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasks);
export default __webpack_public_path__ + "static/media/tasks.2c152763914b064d7143c2ee72b65a5e.svg";
export { ForwardRef as ReactComponent };